import { render, staticRenderFns } from "./artistImages.vue?vue&type=template&id=d52951ae&scoped=true&"
import script from "./artistImages.vue?vue&type=script&lang=js&"
export * from "./artistImages.vue?vue&type=script&lang=js&"
import style0 from "./artistImages.vue?vue&type=style&index=0&id=d52951ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52951ae",
  null
  
)

/* custom blocks */
import block0 from "./artistImages.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports